'use strict';

var copy = require('shallow-copy');

var toArray = function toArray(string) {
  return string ? decodeURIComponent(string).split(',') : [];
};

var includes = function includes(current, key, value) {
  return toArray(current[key]).indexOf(value) > -1;
};

var add = function add(current, key, value) {
  var newParams = copy(current);

  var values = toArray(current[key]);
  values.push(value);
  newParams[key] = values.join(',');

  return newParams;
};

var remove = function remove(current, key, valueToRemove) {
  var newParams = copy(current);
  var isArray = Array.isArray(valueToRemove);

  var values = toArray(current[key]);
  var filteredValues = values.filter(function (value) {
    return isArray ? valueToRemove.indexOf(value) === -1 : value !== valueToRemove;
  });

  newParams[key] = filteredValues.join(',');
  if (newParams[key].length === 0) {
    delete newParams[key];
  }

  return newParams;
};

function toggle() {
  return includes.apply(null, arguments) ? remove.apply(null, arguments) : add.apply(null, arguments);
}

module.exports = {
  toggle: toggle,
  remove: remove,
  includes: includes
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/refinement-types/checklist.js
 ** module id = 493
 ** module chunks = 0
 **/